module.exports = __webpack_public_path__ + "img/roundlogo.d6d0318e.png";